// import React, { useState, useEffect } from 'react';
// import './gallery.css';
// import { IoChevronBackOutline, IoChevronForwardOutline, IoClose } from 'react-icons/io5';

// export default function Gallery({ onClose, galleryLoading, setGalleryLoading, galleryLoadingMethod }) {
//   // List of image filenames in the gallery
//   const images = [
//     '1_new.jpg', '2_new.jpg', '3_new.jpg', '4_new.jpg', '01.jpg', '02.jpg', '03.jpg', '04.jpg', '05.jpg', '06.jpg', '07.jpg', '08.jpg',
//     '09.jpg', '10.jpg', '11.jpg', '14.jpg', '15.jpg',
//     '16.jpg', '17.jpg', '18.jpg',
//     '23.jpg', '24.jpg', '25.jpg', '26.jpg', '27.jpg', '28.jpg', '29.jpg',
//     '30.jpg', '32.jpg', '33.jpg', '34.jpg', '35.jpg', '36.jpg',
//     '37.jpg', '38.jpg', '39.jpg', '40.jpg', '41.jpg', '42.jpg', '43.jpg',
//     '44.jpg', '45.jpg', '46.jpg', '47.jpg', '48.jpg', '49.jpg', '50.jpg',
//     '51.jpg', '52.jpg'
//   ];

//   const [selectedIndex, setSelectedIndex] = useState(0);
//   // Preload all images
//   useEffect(() => {
//     let loadedCount = 0;
//     let mounted = true;

//     /* eslint-disable-next-line no-undef */
//     const timeout = window.setTimeout(() => {
//       if (loadedCount === images.length && mounted) {
//         setGalleryLoading(false);
//       }
//     }, 1000);

//     images.forEach(src => {
//       /* eslint-disable-next-line no-undef */
//       const img = window.document.createElement('img');
//       img.onload = () => {
//         if (!mounted) return;
//         loadedCount++;
//         if (loadedCount === images.length) {
//           setGalleryLoading(false);
//         }
//       };

//       img.onerror = () => {
//         if (!mounted) return;
//         loadedCount++;
//         if (loadedCount === images.length) {
//           setGalleryLoading(false);
//         }
//       };

//       img.src = `/gallery/${src}`;
//     });

//     return () => {
//       mounted = false;
//       /* eslint-disable-next-line no-undef */
//       window.clearTimeout(timeout);
//     };
//   }, [images]);

//   // Show loader while images are galleryLoading
//   if (galleryLoading) {
//     return (
//       <div className="gallery-loader">
//         <div className="loader"></div>
//         <p>Loading gallery...</p>
//       </div>
//     );
//   }

//   // Add close button
//   const closeButton = (
//     <button
//       onClick={onClose}
//       style={{
//         position: 'absolute',
//         top: '20px',
//         right: '20px',
//         background: 'rgba(255, 255, 255, 0.1)',
//         border: 'none',
//         borderRadius: '50%',
//         width: '40px',
//         height: '40px',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         cursor: 'pointer',
//         color: 'white',
//         fontSize: '24px',
//         zIndex: `${galleryLoadingMethod ? '11000' : '0'}`
//       }}
//     >
//       <IoClose />
//     </button>
//   );

//   const nextImage = () => {
//     setSelectedIndex((prev) => (prev + 1) % images.length);
//   };

//   const prevImage = () => {
//     setSelectedIndex((prev) => (prev - 1 + images.length) % images.length);
//   };

//   const selectImage = (index) => {
//     setSelectedIndex(index);
//   };

//   return (
//     <div style={{
//       zIndex: `${galleryLoadingMethod ? '10999' : '0'}`,
//       position: 'absolute',
//       height: '100vh',
//       width: '100vw',
//       display: 'flex',
//       flexDirection: 'column',
//       backgroundColor: 'rgba(0, 0, 0, 0.9)',
//     }}>
//       {closeButton}
//       {/* Main image view */}
//       <div style={{
//         flex: 1,
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         position: 'relative',
//         padding: '20px'
//       }}>
//         {/* Navigation buttons */}
//         <button
//           onClick={prevImage}
//           style={{
//             position: 'absolute',
//             left: '20px',
//             background: 'rgba(255, 255, 255, 0.1)',
//             border: 'none',
//             borderRadius: '50%',
//             width: '40px',
//             height: '40px',
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             cursor: 'pointer',
//             color: 'white',
//             fontSize: '24px'
//           }}
//         >
//           <IoChevronBackOutline />
//         </button>

//         <img
//           src={`/gallery/${images[selectedIndex]}`}
//           alt=""
//           style={{
//             maxHeight: '70vh',
//             maxWidth: '90%',
//             objectFit: 'contain',
//             borderRadius: '8px'
//           }}
//         />

//         <button
//           onClick={nextImage}
//           style={{
//             position: 'absolute',
//             right: '20px',
//             background: 'rgba(255, 255, 255, 0.1)',
//             border: 'none',
//             borderRadius: '50%',
//             width: '40px',
//             height: '40px',
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             cursor: 'pointer',
//             color: 'white',
//             fontSize: '24px'
//           }}
//         >
//           <IoChevronForwardOutline />
//         </button>
//       </div>

//       {/* Thumbnails
//       <div style={{
//         height: '120px',
//         padding: '10px',
//         display: 'flex',
//         overflowX: 'auto',
//         gap: '10px',
//         backgroundColor: 'rgba(0, 0, 0, 0.5)',
//       }}>
//         {images.map((src, i) => (
//           <img
//             key={i}
//             src={`/gallery/${src}`}
//             alt=""
//             style={{
//               height: '100px',
//               width: '150px',
//               objectFit: 'cover',
//               cursor: 'pointer',
//               borderRadius: '4px',
//               border: i === selectedIndex ? '2px solid white' : '2px solid transparent',
//               opacity: i === selectedIndex ? 1 : 0.6,
//               transition: 'all 0.2s ease'
//             }}
//             onClick={() => selectImage(i)}
//           />
//         ))}
//       </div> */}
//     </div>
//   );
// }

/* eslint-env browser */
import React from 'react';
import { IoChevronBackOutline, IoChevronForwardOutline, IoClose } from 'react-icons/io5';

/**
 * Shared image list — keep OUTSIDE the component so effects don't re-run.
 * Replace with your real filenames.
 */
const GALLERY_IMAGES = [
  '01.jpg',
  '02.jpg',
  '03.jpg',
  '04.jpg',
  '05.jpg',
  '06.jpg',
  '07.jpg',
  '08.jpg',
  '09.jpg',
  '10.jpg',
  '11.jpg',
  '14.jpg',
  '15.jpg',
  '16.jpg',
  '17.jpg',
  '18.jpg',
  '23.jpg',
  '24.jpg',
  '25.jpg',
  '26.jpg',
  '27.jpg',
  '28.jpg'
  // '29.jpg',
  // '30.jpg',
  // '32.jpg',
  // '33.jpg',
  // '34.jpg',
  // '35.jpg',
  // '36.jpg',
  // '37.jpg',
  // '38.jpg',
  // '39.jpg',
  // '40.jpg',
  // '41.jpg',
  // '42.jpg',
  // '43.jpg',
  // '44.jpg',
  // '45.jpg',
  // '46.jpg',
  // '47.jpg',
  // '48.jpg',
  // '49.jpg',
  // '50.jpg',
  // '51.jpg',
  // '52.jpg'
];

/** ---------- Small presentational helpers (same inline styles as your original) ---------- */

function CloseButton({ onClick, zIndex = 0 }) {
  return (
    <button
      onClick={onClick}
      style={{
        position: 'absolute',
        top: '20px',
        right: '20px',
        background: 'rgba(255, 255, 255, 0.1)',
        border: 'none',
        borderRadius: '50%',
        width: '40px',
        height: '40px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        color: 'white',
        fontSize: '24px',
        zIndex
      }}
      aria-label="Close gallery"
    >
      <IoClose />
    </button>
  );
}

function NavButton({ side, onClick }) {
  const commonStyle = {
    position: 'absolute',
    background: 'rgba(255, 255, 255, 0.1)',
    border: 'none',
    borderRadius: '50%',
    width: '40px',
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    color: 'white',
    fontSize: '24px'
  };
  return (
    <button
      onClick={onClick}
      style={{
        ...commonStyle,
        ...(side === 'left' ? { left: '20px' } : { right: '20px' })
      }}
      aria-label={side === 'left' ? 'Previous image' : 'Next image'}
    >
      {side === 'left' ? <IoChevronBackOutline /> : <IoChevronForwardOutline />}
    </button>
  );
}

/** ---------- Base layout wrapper (matches your loader + overlay styles) ---------- */

function GalleryLayout({ onClose, galleryLoading, galleryLoadingMethod, children }) {
  if (galleryLoading) {
    // Uses your .gallery-loader and .loader classes from gallery.css
    return (
      <div className="gallery-loader">
        <div className="loader"></div>
        <p>Loading gallery...</p>
      </div>
    );
  }

  return (
    <div
      style={{
        zIndex: `${galleryLoadingMethod ? '10999' : '0'}`,
        position: 'absolute',
        height: '100vh',
        width: '100vw',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: 'rgba(0, 0, 0, 0.9)'
      }}
    >
      <CloseButton onClick={onClose} zIndex={galleryLoadingMethod ? 11000 : 0} />
      {children}
    </div>
  );
}

/** ---------- OPTION A: Smart preload (few first, then neighbors) ---------- */

export function GallerySmart({
  onClose,
  galleryLoading,
  setGalleryLoading,
  galleryLoadingMethod,
  images = GALLERY_IMAGES,
  initialIndex = 0,
  initialPreloadCount = 3 // how many to ensure before we hide the loader
}) {
  const [selectedIndex, setSelectedIndex] = React.useState(initialIndex);
  const cacheRef = React.useRef([]); // retain Image objects, avoid GC/eviction

  // Preload FIRST FEW so we can show instantly; do NOT flood the device
  React.useEffect(() => {
    let cancelled = false;
    let loaded = 0;
    const first = Array.from({ length: Math.min(initialPreloadCount, images.length) }, (_, i) => i);

    first.forEach((i) => {
      const img = new Image();
      cacheRef.current.push(img);
      img.onload = img.onerror = () => {
        if (cancelled) return;
        loaded += 1;
        if (loaded === first.length) {
          setGalleryLoading(false);
        }
      };
      img.decoding = 'async';
      img.src = `/gallery/${images[i]}`;
    });

    return () => {
      cancelled = true;
    };
    // don't depend on `images` object identity if you keep it outside component
  }, [setGalleryLoading, initialPreloadCount, images]);

  // Prefetch neighbors whenever selection changes
  React.useEffect(() => {
    if (!images.length) return;
    const next = (selectedIndex + 1) % images.length;
    const prev = (selectedIndex - 1 + images.length) % images.length;
    [next, prev].forEach((i) => {
      const img = new Image();
      cacheRef.current.push(img);
      img.decoding = 'async';
      img.src = `/gallery/${images[i]}`;
    });
  }, [selectedIndex, images]);

  const nextImage = () => setSelectedIndex((i) => (i + 1) % images.length);
  const prevImage = () => setSelectedIndex((i) => (i - 1 + images.length) % images.length);

  return (
    <GalleryLayout onClose={onClose} galleryLoading={galleryLoading} galleryLoadingMethod={galleryLoadingMethod}>
      {/* Main image view — same inline styles as your original */}
      <div
        style={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
          padding: '20px'
        }}
      >
        <NavButton side="left" onClick={prevImage} />
        <img
          src={`/gallery/${images[selectedIndex]}`}
          alt=""
          fetchpriority="high"
          decoding="async"
          loading="eager"
          style={{
            maxHeight: '70vh',
            maxWidth: '90%',
            objectFit: 'contain',
            borderRadius: '8px'
          }}
        />
        <NavButton side="right" onClick={nextImage} />
      </div>
    </GalleryLayout>
  );
}

/** ---------- OPTION B: Sequential preload (one-by-one from the start) ---------- */

export function GallerySequential({
  onClose,
  galleryLoading,
  setGalleryLoading,
  galleryLoadingMethod,
  images = GALLERY_IMAGES,
  initialIndex = 0,
  showAfterCount = 1 // set to 1 (first) or 2/3 if you want more warmed up
}) {
  const [selectedIndex, setSelectedIndex] = React.useState(initialIndex);
  const cacheRef = React.useRef([]);

  React.useEffect(() => {
    let cancelled = false;
    let loadedCount = 0;

    (async function sequential() {
      for (let i = 0; i < images.length; i++) {
        if (cancelled) break;
        // eslint-disable-next-line no-await-in-loop
        await new Promise((resolve) => {
          const img = new Image();
          cacheRef.current.push(img);
          img.onload = img.onerror = () => {
            loadedCount += 1;
            if (loadedCount === showAfterCount) {
              setGalleryLoading(false);
            }
            resolve();
          };
          img.decoding = 'async';
          img.src = `/gallery/${images[i]}`;
        });
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [images, setGalleryLoading, showAfterCount]);

  const nextImage = () => setSelectedIndex((i) => (i + 1) % images.length);
  const prevImage = () => setSelectedIndex((i) => (i - 1 + images.length) % images.length);

  return (
    <GalleryLayout onClose={onClose} galleryLoading={galleryLoading} galleryLoadingMethod={galleryLoadingMethod}>
      {/* Main image view — same inline styles as your original */}
      <div
        style={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
          padding: '20px'
        }}
      >
        <NavButton side="left" onClick={prevImage} />
        <img
          src={`/gallery/${images[selectedIndex]}`}
          alt=""
          fetchpriority="high"
          decoding="async"
          loading="eager"
          style={{
            maxHeight: '70vh',
            maxWidth: '90%',
            objectFit: 'contain',
            borderRadius: '8px'
          }}
        />
        <NavButton side="right" onClick={nextImage} />
      </div>
    </GalleryLayout>
  );
}

/** ---------- Convenience default export ---------- */
/** <Gallery mode="smart" ... /> or <Gallery mode="sequential" ... /> */
export default function Gallery(props) {
  const { mode = 'smart' } = props;
  if (mode === 'sequential') {
    return <GallerySequential {...props} />;
  }
  return <GallerySmart {...props} />;
}
